module.exports = __webpack_public_path__ + "img/logo_blanco.d66ae36c.png";